import formatCalendarDate from './formatCalendarDate';

function foldLine(value) {
  const parts = [];
  let length = 75;
  while (value.length > length) {
    parts.push(value.slice(0, length));
    value = value.slice(length);
    length = 74;
  }
  parts.push(value);
  return parts.join('\n\t');
}

function formatText(value) {
  if (!value) return null;

  return value
    .replace(/\\/gm, '\\\\')
    .replace(/\r?\n/gm, '\\n')
    .replace(/;/gm, '\\;')
    .replace(/,/gm, '\\,');
}

function formatGeo(latitude, longitude) {
  if (!latitude || !longitude) return null;

  return `${latitude};${longitude}`;
}

function buildIcal(calendarEvent) {
  const parts = [
    ['BEGIN', 'VCALENDAR'],
    ['VERSION', '2.0'],
    ['PRODID', '-//LocalMed//Online Scheduling//EN'],
    ['DTSTAMP', formatCalendarDate(new Date())],
    ['BEGIN', 'VEVENT'],
    ['UID', `${formatText(calendarEvent.uid) || Date.now()}@localmed.com`],
    ['URL', formatText(calendarEvent.url)],
    ['SUMMARY', formatText(calendarEvent.title)],
    ['DESCRIPTION', formatText(calendarEvent.description)],
    ['DTSTART', formatCalendarDate(calendarEvent.startTime)],
    ['DTEND', formatCalendarDate(calendarEvent.endTime)],
    ['LOCATION', formatText(calendarEvent.location)],
    ['GEO', formatGeo(calendarEvent.latitude, calendarEvent.longitude)],
    ['TRANSP', 'OPAQUE'],
    ['STATUS', formatText(calendarEvent.status)],
    ['END', 'VEVENT'],
    ['END', 'VCALENDAR'],
  ];
  return parts
    .filter(([, value]) => value != null && value !== '')
    .map((line) => foldLine(line.join(':')))
    .join('\n');
}

export default function buildIcalUrl(calendarEvent) {
  const ics = buildIcal(calendarEvent);
  return encodeURI(`data:text/calendar;charset=utf8,${ics}`);
}
